module.exports = __webpack_public_path__ + "assets/73f26bf98a715ecab4d2287ff3a02ad0.woff";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-all-400-normal.woff
// module id = 274
// module chunks = 121